import React from "react";
import classNames from "classnames";
import { Link } from "@/components/Link";
import { IconList } from "@/components/IconList";
import { Icons } from "@/types/icons";
import { checkValidURL } from "@/utils/formHelper";
import "./PreviewLocationBlock.scss";

export type LocationType = {
  address?: string;
  numeration?: string;
  city?: string;
  zipCode?: string;
  state?: string;
  country?: string;
  fullAddress?: string;
};

export interface PreviewLocationBlockProps {
  /** Datos de ubicación */
  data: LocationType;
  /** Título de la sección */
  title: string;
  /** Clase CSS adicional */
  className?: string;
}

/**
 * Componente estandarizado para bloques de ubicación
 * Usado en Business, Event y Coupon previews
 * Migrado de src/components/PreviewLocationBlock/ con mejoras
 */
export function PreviewLocationBlock({ data, title, className }: PreviewLocationBlockProps) {
  const { address, numeration, city, zipCode, state, country, fullAddress } = data || {};

  // Do not render if there is no location data
  if (!data || (!address && !numeration && !city && !zipCode && !state && !country)) {
    return null;
  }

  const addressMapsURL = `http://maps.google.com/?q=${encodeURIComponent(fullAddress)}`;

  const containerClasses = classNames(
    "u-card",
    "business-location",
    "preview-location-block",
    className
  );

  return (
    <div className={containerClasses}>
      <IconList
        iconItem
        items={{
          icon: Icons.location,
          title,
        }}
        tag="h6"
        semibold
      />
      <Link
        className="business-link preview-location-block__link"
        href={checkValidURL(addressMapsURL) || ""}
        externalLink
        prefetch={false}
      >
        {fullAddress}
      </Link>
    </div>
  );
}
